<!-- 组织切换对话框。布局照 account.component.html 的组织内容区：当前用户条（头像+名+账号入口）
     在上，下面是个人组织 + 真实组织的卡片网格。

     组织功能未启用时列表里只有个人组织一张；「创建组织」按钮在功能启用时才出现。
     点卡片即切换当前组织（个人组织回空选中、真实组织设当前）并关窗回首页。 -->
<div class="org-dialog">
  <!-- 顶部用户条：头像 + 姓名；右侧「账号」链接进账号页（退出/设置都在那），关弹窗再跳 -->
  <div class="org-dialog-head">
    <!-- 左侧一组：头像 + 用户名 + 「账号」链接（用 nz-space 排列） -->
    <nz-space nzSize="small" [nzAlign]="'center'" class="org-dialog-head-left">
      <div *nzSpaceItem>
        <nz-avatar nzIcon="user" [nzSrc]="account.user().avatar"></nz-avatar>
      </div>
      <div *nzSpaceItem>
        <span class="org-dialog-user">{{ account.user().name }}</span>
      </div>
      <div *nzSpaceItem>
        <a class="org-dialog-account" (click)="goAccount()">{{ '账号' | translate }}</a>
      </div>
    </nz-space>

    <!-- 右侧：组织功能开关（「组织」指示文本 + 启用/禁用）。启用了才显示真实组织与「创建组织」按钮 -->
    <div class="org-dialog-toggle">
      <span class="org-dialog-toggle-label">{{ '组织' | translate }}</span>
      <nz-radio-group
        [ngModel]="organizationEnabled()"
        (ngModelChange)="onToggleEnabled($event)"
        nzButtonStyle="solid"
        nzSize="small"
      >
        <label nz-radio-button [nzValue]="true">{{ '启用' | translate }}</label>
        <label nz-radio-button [nzValue]="false">{{ '禁用' | translate }}</label>
      </nz-radio-group>
    </div>
  </div>

  <!-- 组织功能**启用**：组织卡片网格（参照账号页）——第一张个人组织、当前组织勾选；
     组织功能**未启用**：不显示个人组织卡，直接给账号信息（ID/名称/平台/邮箱）。 -->
  @if (organizationEnabled()) {
    <nz-spin [nzSpinning]="loading()">
      <nz-row [nzGutter]="[8, 8]">
        @for (org of displayOrganizations(); track $index) {
          <nz-col [nzSpan]="8" class="card-col" [class.personal]="org.personal" (click)="selectOrganization(org)">
            <nz-card [nzHoverable]="true" [nzActions]="[detailAction]">
              <nz-card-meta [nzTitle]="title" [nzDescription]="desc"></nz-card-meta>
            </nz-card>

            <ng-template #title>
              <span>
                <span>{{ org.name }}</span>
                <!-- 个人组织的角标：它不是一份组织，是当前账号自己 -->
                @if (org.personal) {
                  <span class="personal-badge">{{ '个人' | translate }}</span>
                }
                @if (account.isCurrentOrganization(org)) {
                  <span class="card-check"><nz-icon nzType="check" /></span>
                }
              </span>
            </ng-template>

            <!-- 真实组织显示代码，个人组织显示「个人」（虚拟组织，没有 code/id） -->
            <ng-template #desc>{{ org.personal ? ('-' | translate) : org.id }}</ng-template>

            <!-- 组织「详情」入口（与账号页同口径）：个人组织→账号详情、真实组织→组织详情。
                 点它**不**触卡片的 selectOrganization —— stopPropagation 挡掉冒泡；进详情前先关弹窗 -->
            <ng-template #detailAction>
              <a (click)="goDetail(org); $event.stopPropagation()">{{ '详情' | translate }}</a>
            </ng-template>
          </nz-col>
        }
      </nz-row>
    </nz-spin>
  } @else {
    <div class="org-dialog-account-info">
      <nz-descriptions [nzColumn]="2" [nzSize]="'small'" nzBordered>
        <nz-descriptions-item [nzTitle]="'用户ID' | translate">
          <!-- 点用户 ID 即复制（与 AccountComponent 同款：链接 + 复制图标 + 提示） -->
          @if (account.user().id) {
            <a (click)="onCopy(account.user().id)">{{ account.user().id }}</a>
            <nz-icon
              nz-tooltip
              nzTooltipTitle="{{ '复制' | translate }}"
              nzType="copy"
              nzTheme="outline"
              class="copy-icon"
              (click)="onCopy(account.user().id)"
            />
          } @else {
            -
          }
        </nz-descriptions-item>
        <nz-descriptions-item [nzTitle]="'用户名称' | translate">{{ account.user().name || '-' }}</nz-descriptions-item>
        <nz-descriptions-item [nzTitle]="'平台' | translate">{{ account.user().platform || '-' }}</nz-descriptions-item>
        <nz-descriptions-item [nzTitle]="'邮箱' | translate">{{ account.user().email || '-' }}</nz-descriptions-item>
      </nz-descriptions>
    </div>
  }

  <!-- 底部条：左「创建组织」（功能启用才有意义），右「退出账号」（primary + danger）。
       创建用普通按钮而非账号页那颗 fixed 悬浮钮（悬浮钮按视口定位，放进小弹窗会飘到角落） -->
  <div class="org-dialog-foot">
    @if (organizationEnabled()) {
      <button nz-button (click)="onCreateOrganization()">
        <nz-icon nzType="plus" /> {{ '创建组织' | translate }}
      </button>
    }
    <button nz-button nzType="primary" nzDanger="true" (click)="logout()">
      {{ '退出账号' | translate }}
    </button>
  </div>
</div>
